module.exports = __webpack_public_path__ + "fonts/Simple-Line-Icons.0cb0b9c5.woff2";